import { createContext } from 'react'
import UserType from '../interfaces/User.type'

const UserContext = createContext<UserType>({} as UserType)

export default UserContext
